import { ClickAwayListener, Paper, Popper } from '@mui/material';
import { ReactElement, useRef } from 'react';
import debounce from 'lodash.debounce';

import { CategoryTreeMenuProps } from '../menu/category-tree-menu';
import { CategoryTreePopupContent } from './category-tree-popup-content';

export const CategoryTreePopup = (props: CategoryTreeMenuProps): ReactElement => {
    const delayedClose = useRef(debounce(() => props.onClose(), 1000)).current;

    const handleLeave = (): void => {
        delayedClose();
    };

    const handleEnter = (): void => {
        delayedClose.cancel();
    };

    return (
        <Popper
            placement="bottom-start"
            open={!!props.isOpen}
            disablePortal={true}
            anchorEl={props.anchorEl}
            sx={{ zIndex: theme => theme.zIndex.drawer }}
        >
            <ClickAwayListener onClickAway={props.onClose}>
                <div onMouseLeave={handleLeave} onMouseEnter={handleEnter}>
                    <Paper sx={{ display: 'flex' }}>
                        <CategoryTreePopupContent onSelect={props.onSelect}>{props.children}</CategoryTreePopupContent>
                    </Paper>
                </div>
            </ClickAwayListener>
        </Popper>
    );
};
